// extracted by mini-css-extract-plugin
module.exports = {"navDesktop":"Nav_navDesktop__I7aMT"};